import { useLocation } from 'react-router-dom'

export const useUrlSearchParams = (): URLSearchParams => {
  return new URLSearchParams(useLocation().search)
}
